import React, {useEffect, useState} from 'react';
import './style.scss';
import config from './config.json';
import media from '../../media';

export default function Topbar(props) {
    const [activeTab, setActiveTab] = useState(-1);
    const [showPanel, setShowPanel] = useState(false);

    useEffect(() => {
        window.addEventListener('resize', onWindowResize);
        window.addEventListener('scroll', onWindowScroll);

        onWindowScroll();

        return () => {
            window.removeEventListener("resize", onWindowResize);
            window.removeEventListener("scroll", onWindowScroll);
        }
    }, []);

    return (
        <div className="topbar">
            <div className="inner">
                <a className="logo" href="/"></a>

                <nav className="tabs">
                    {config.tabs.map((tab, key) => {
                        return(
                            <button className={"tab"+(activeTab===key?" active":"")} key={key} onClick={()=>{onTabClick(tab.cssClass)}}>{tab.name}</button>
                        );
                    })}
                </nav>

                <a className={"menu-btn"+(showPanel?" active":"")} onClick={onMenuClick}>
                    <span className="line line1"></span>
                    <span className="line line2"></span>
                    <span className="line line3"></span>
                </a>
            </div>

            <div className={"overlay"+(showPanel?" open":"")}>
                <div className="panel">
                    <nav className="tabs">
                        {config.tabs.map((tab, key) => {
                            return(
                                <button className={"tab"+(activeTab===key?" active":"")} key={key} onClick={()=>{onTabClick(tab.cssClass)}}>{tab.name}</button>
                            );
                        })}
                    </nav>
                </div>
            </div>
        </div>
    )

    function onTabClick(cssClass) {
        var element = document.getElementsByClassName(cssClass)[0];

        if (element!==undefined) {
            var position = element.getBoundingClientRect().top + window.scrollY - 80; //80 is the topbar offset
            window.scrollTo({top:position, behavior:"smooth"});
        }
        else {
            window.open("/", "_self"); //Go to home page
        }

        setShowPanel(false);
    }

    function onMenuClick(e) {
        e.preventDefault();

        if (showPanel) {
            setShowPanel(false);
        }
        else {
            setShowPanel(true);
        }
    }

    function onWindowResize() {
        setShowPanel(false);
    }

    function onWindowScroll() {
        var activeTabIndex = getActiveTabIndex();

        if (activeTabIndex!==null) {
            setActiveTab(activeTabIndex);
        }
    }

    function getActiveTabIndex() {
        var activeTabIndex = null;
        var distances = getDistances();
        //var visibleTabs = getVisibleTabs();
        var minDistance = getMinDistance(distances);

        if (minDistance!==null) {
            activeTabIndex = distances.indexOf(minDistance);
        }

        return activeTabIndex;
    }

    function getDistances() {
        var distances = new Array(config.tabs.length).fill(false);
        var currElem;
        var currRect;
        var i;

        for (i=0; i<config.tabs.length; i++) {
            currElem = document.getElementsByClassName(config.tabs[i].cssClass)[0];

            if (currElem!==undefined) {
                currRect = currElem.getBoundingClientRect();
                distances[i] = Math.abs(80 - currRect.top); //80 is an offset for the topbar height
            }
            else {
                distances[i] = null;
            }
        }

        return distances;
    }

    function getMinDistance(distances) {
        var minDistance = distances.find((el) => el!==null);
        var i;

        if (minDistance!==undefined) {
            for (i=1; i<distances.length; i++) {
                if (distances[i]!==null) {
                    if (distances[i]<minDistance) {
                        minDistance = distances[i];
                    }
                }
            }
        }
        else {
            minDistance = null;
        }        

        return minDistance;
    }

    function getVisibleTabs() {
        var visibleTabs = new Array(config.tabs.length).fill(false);
        var currElem;
        var i;

        for (i=0; i<config.tabs.length; i++) {
            currElem = document.getElementsByClassName(config.tabs[i].cssClass)[0];

            if (currElem!==undefined) {
                visibleTabs[i] = isElementInViewport(currElem);
            }
        }

        return visibleTabs;
    }

    function isElementInViewport(element) {
        var rect = element.getBoundingClientRect();

        return (rect.top <= (window.innerHeight || document.documentElement.clientHeight)) && (rect.bottom >= 80); //80 is an offset for the topbar height
    }
}
